import { render, staticRenderFns } from "./ClaimDocumentsCard.vue?vue&type=template&id=12784d0d&scoped=true&lang=pug&"
import script from "./ClaimDocumentsCard.vue?vue&type=script&lang=js&"
export * from "./ClaimDocumentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12784d0d",
  null
  
)

export default component.exports